import { atom, injectAtomValue, injectEffect, injectStore, api, injectAtomInstance } from '@zedux/react';
import { IUnseenCountPayload, IItemSeenPayload, INewUnseenItemPayload } from '../types';
import { socketAtom, userInfoAtom } from './socket';
import { convert_to_fa } from '@src/functions/farsi';

const SECTION_TYPE_CHAT = 4

// export type IListenerEvent =
//     | { type: 'unseen-count'; payload: IUnseenCountPayload }
//     | { type: 'item-seen'; payload: IItemSeenPayload }
//     | { type: 'new-unseen-item'; payload: INewUnseenItemPayload }

/**
 * Global site listener atom — handles non-chat real-time notifications.
 * Joins a room keyed by the user's resolved listener key (server uses bossId first, else userId).
 * Exposes the last received event via atom state; consumers react to state changes.
 * The user writes their own node-modification logic by consuming lastEvent.
 */
export const listenerAtom = atom("listener", () => {
    const socket = injectAtomValue(socketAtom);
    const userInfoInstance = injectAtomInstance(userInfoAtom);
    // const store = injectStore<IListenerEvent | null>(null);

    injectEffect(() => {
        if (!socket) return;

        const handleUnseenCount = (payload: IUnseenCountPayload) => {
            // store.setState({ type: 'unseen-count' as const, payload } as IListenerEvent);
            const { sectionType, unseenCount, userId, asSelf, asBoss } = payload
            if (!document) {
                return
            }
            const target = document.querySelector(`[data-unseen-section-total='${sectionType}']`) as HTMLElement | null
            if (target) {
                if (sectionType == SECTION_TYPE_CHAT) {
                    // Chat Section
                    if ((userId == 0 || (userId != userInfoInstance.getState()?.userId || asBoss)) && !asSelf) {
                        target.dataset.unseenCountBoss = unseenCount == 0 ? '' : String(unseenCount)
                    } else {
                        target.dataset.unseenCountSelf = unseenCount == 0 ? '' : String(unseenCount)
                    }
                    const total = Number(target.dataset.unseenCountBoss || 0) + Number(target.dataset.unseenCountSelf || 0)
                    target.dataset.unseenCount = total == 0 ? '' : convert_to_fa(String(total))
                } else {
                    // Other Sections
                    target.dataset.unseenCount = unseenCount == 0 ? '' : convert_to_fa(String(unseenCount))
                }
            }
        }

        const handleItemSeen = (payload: IItemSeenPayload) => {
            // store.setState({ type: 'item-seen' as const, payload } as IListenerEvent);
            if (!document) {
                return
            }
            const target = document.querySelector(
                `[data-unseen-section='${payload.sectionType}'][data-unseen-item-id='${payload.itemId}']`
            ) as HTMLElement | null
            if (target) {
                target.dataset.unseenStatus = ''
            }
        };

        const handleNewUnseenItem = (payload: INewUnseenItemPayload) => {
            if (!document) {
                return
            }
            const target = document.querySelector(
                `[data-unseen-section='${payload.sectionType}'][data-unseen-item-id='${payload.itemId}']`
            ) as HTMLElement | null
            if (target) {
                target.dataset.unseenStatus = '1'
            }
        }

        socket.on('unseen-count', handleUnseenCount);
        socket.on('item-seen', handleItemSeen);
        socket.on('new-unseen-item', handleNewUnseenItem);
        socket.emit('notification:join');

        return () => {
            socket.off('unseen-count', handleUnseenCount);
            socket.off('item-seen', handleItemSeen);
            socket.off('new-unseen-item', handleNewUnseenItem);
            socket.emit('notification:leave');
        };
    }, [socket]);

    return true;
})
